import { useQuery } from "@tanstack/react-query";

import { useSelectedWorkspaceContext } from "common/context/SelectedWorkspaceContext";
import getQueryKeys from "common/datahooks/getQueryKeys";
import { get } from "common/helpers/HTTP";

import type { LinkedInPost } from "../types";

async function getLinkedInPostRequest(
  workspaceId: string,
  accountId: string,
  postId: string,
): Promise<LinkedInPost> {
  return (
    await get(`workspaces/${workspaceId}/accounts/${accountId}/posts/${postId}`)
  ).post;
}

export default function useLinkedInPost(accountId: string, postId: string) {
  const { id: workspaceId } = useSelectedWorkspaceContext();
  const { leadListSourcesKeys } = getQueryKeys(workspaceId);

  const {
    data: linkedInPost,
    isLoading: isLoadingLinkedInPost,
    error: linkedInPostError,
  } = useQuery({
    queryKey: leadListSourcesKeys.linkedInPost(accountId, postId),
    queryFn: () => getLinkedInPostRequest(workspaceId, accountId, postId),
    gcTime: 0,
    enabled: !!accountId && !!postId,
  });

  return {
    linkedInPost,
    isLoadingLinkedInPost,
    linkedInPostError,
  };
}
